export const id = 'shift2DY';
export const name = 'Shift 2D Y';
export const DOMAIN_UPDATE_RULES = {
    updateXDomain: false,
    updateYDomain: true,
};
export function apply(datum2D, options) {
    const { shift } = options;
    const data = { ...datum2D.data };
    for (const key in data) {
        data[key].minY += shift;
        data[key].maxY += shift;
    }
}
export function isApplicable() {
    return true;
}
export function reduce(previous, next) {
    const { shift: previousValue = 0 } = previous;
    const { shift: nextShift } = next;
    return {
        once: true,
        reduce: previousValue + nextShift,
    };
}
//# sourceMappingURL=shiftY.js.map